<template>
  <div class="contact-wrap">
    <div class="contact-box">
      <div class="contact-left">
        <div class="contact-padding">
          <div class="contact-type">
            <img src="../assets/img/contact_icon_phone.png" alt="">
            联系电话
          </div>
          <div class="contact-div">电话号码：<span>{{serverList.server_mobile}}</span></div>
          <div class="contact-div">工作时间：<span>周一至周五（节假日除外） 09:00-18:00</span></div>
        </div>
      </div>
      <div class="contact-right">
        <div class="contact-padding">
          <div class="contact-type">
            <img src="../assets/img/contact_icon_wechat.png" alt="">
            微信二维码
          </div>
          <div class="contact-div">
            <img :src="serverList.wechat_code" alt="">
          </div>
        </div>
      </div>
    </div>
    <Spin size="large" fix v-show="loading"></Spin>
  </div>
</template>

<script>
  import {
    getServerConfig
  } from '@/api/user'
  import {
    Spin
  } from 'view-design'
  export default {
    name: "Contact",
    components: {
      Spin
    },
    data: function() {
      return {
        serverList: {
          wechat_code: '',
          server_mobile: ''
        },
        loading: false
      }
    },
    mounted: function() {
      var that = this
      this.loading = true
      getServerConfig().then(response => {
        that.loading = false
        that.serverList.wechat_code = response.data.wechat_code
        that.serverList.server_mobile = response.data.server_mobile;
      }).catch(error => {
        that.loading = false
        console.log(error)
        that.$Message.error('加载客服信息失败,请稍后再试!')
      })
    }
  }
</script>

<style>
  .contact-wrap {
    position: absolute;
    width: 40%;
    background: #FFFFFF;
    color: #666666;
    min-width: 400px;
    z-index: 999;
    box-shadow: 0px 1px 1px 1px #00000012;
    top: 80px;
  }

  .contact-wrap .contact-box {
    padding: 0 30px;
  }

  .contact-wrap .contact-box .contact-left {
    float: left;
    width: 60%;
  }

  .contact-wrap .contact-box .contact-right {
    float: left;
    width: 40%;
  }

  .contact-wrap .contact-box .contact-left .contact-padding,
  .contact-wrap .contact-box .contact-right .contact-padding {
    padding: 25px 5px;
  }

  .contact-wrap .contact-box .contact-type {
    padding-bottom: 20px;
    font-family: Alibaba-PuHuiTi-M;
    font-size: 16px;
    color: #222222;
  }

  .contact-wrap .contact-box .contact-type img {
    width: 24px;
    height: 24px;
  }

  .contact-div {
    padding: 3px 0;
  }

  .contact-div img {
    /* height: 100%;
    width: 100%; */
    width: 120px;
  }

  @media (min-width: 768px) {
    .contact-wrap {
      width: 40%
    }
  }

  @media (min-width: 992px) {
    .contact-wrap {
      width: 37%
    }
  }

  @media (min-width: 1200px) {
    .contact-wrap {
      width: 33%
    }
  }

  @media (min-width: 1400px) {
    .contact-wrap {
      width: 30%
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue